import React, { Component } from 'react'

class DashboardTrackSection extends Component {
  constructor(props) {
    super(props)

    this.sectionRef = React.createRef()
    this.observer = null
    this.viewTimer = null
    this.hasTracked = false
    this.isCurrentlyVisible = false
  }

  componentDidMount() {
    this.startObserver()
  }

  componentWillUnmount() {
    this.cleanUpObserver()
  }

  startObserver = () => {
    const element = this.sectionRef.current

    if (
      !element ||
      typeof IntersectionObserver === 'undefined'
    ) {
      //console.log( 'IntersectionObserver unavailable:', this.props.sectionName )
      return
    }

    const {
      sectionName,
      threshold = 0.25,
      minimumViewTime = 1000,
      onSectionReached,
    } = this.props

    //console.log( 'Start observing:', sectionName, element.getBoundingClientRect() )

    this.observer = new IntersectionObserver(
      entries => {
        const entry = entries[0]

        /*console.log('Observer update:', {
          section: sectionName,
          isIntersecting: entry.isIntersecting,
          intersectionRatio: entry.intersectionRatio,
          top: entry.boundingClientRect.top,
          bottom: entry.boundingClientRect.bottom,
          height: entry.boundingClientRect.height,
        })*/

        if (this.hasTracked) {
          return
        }

        const isVisible =
          entry.isIntersecting &&
          entry.intersectionRatio >= threshold

        this.isCurrentlyVisible = isVisible

        if (isVisible) {
          if (this.viewTimer) {
            clearTimeout(this.viewTimer)
          }

          this.viewTimer = setTimeout(() => {
            /*
             * Check again because the user may have
             * scrolled away during the one-second timer.
             */
            if (
              this.hasTracked ||
              !this.isCurrentlyVisible
            ) {
              return
            }

            this.hasTracked = true

            const trackingData = {
              section_name: sectionName,
              visibility_percent: Math.round(
                entry.intersectionRatio * 100
              ),
              minimum_view_time_ms:
                minimumViewTime,
            }

            //console.log( 'SECTION REACHED:', trackingData )

            if (onSectionReached) {
              onSectionReached(trackingData)
            }

            if (this.observer) {
              this.observer.disconnect()
            }
          }, minimumViewTime)
        } else {
          if (this.viewTimer) {
            clearTimeout(this.viewTimer)
            this.viewTimer = null
          }
        }
      },
      {
        threshold: [0, threshold, 1],
      }
    )

    this.observer.observe(element)
  }

  cleanUpObserver = () => {
    this.isCurrentlyVisible = false

    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }

    if (this.viewTimer) {
      clearTimeout(this.viewTimer)
      this.viewTimer = null
    }
  }

  render() {
    const {
      children,
      className = '',
      sectionName,
    } = this.props

    return (
      <div
        ref={this.sectionRef}
        className={`dashboard-tracked-section ${className}`}
        data-dashboard-section={sectionName}
      >
        {children}
      </div>
    )
  }
}

export default DashboardTrackSection
